export enum ModelSemanticType {
  People = "people",
  Households = "households",
  Accounts = "accounts",
  Coupons = "coupons",
}
